import * as React from 'react';
import { ICommand } from '../../../models/commands/ICommand';
import { Facet } from '../../../models/Facet';
import { DeleteAction } from '../../actions/delete/DeleteAction';
import CommandStrings from '../Commands.resx';
import { ShowOnlyWithSelection } from '../../selectionVisibility/SelectionVisibility';
import KeyboardMapStrings from '../../keyboard/KeyboardMap.resx';

export const deleteCommand: ICommand = {
  key: new Facet('delete').id,
  automationId: 'deleteCommand',
  name: CommandStrings.DeleteItem,
  action: <ShowOnlyWithSelection><DeleteAction /></ShowOnlyWithSelection>,
  iconProps: {
    iconName: 'delete'
  },
  keytipProps: {
    keySequences: ['Delete'],
    content: KeyboardMapStrings.deleteDesc
  }
};
